import { css } from "@emotion/css";

export const rowCSS = css`
    cursor: pointer;
`;
